import React from 'react';
import './textbtn.css'

const Textbtn = (props) => {
    return (
        <button className={props.s2}>
            <div className="row">
            <div>{props.text}</div><img src={props.icon} alt='/' />
            </div>
        </button>
        
    );
}
 
export default Textbtn;